export default __webpack_public_path__ + "static/media/roadmap_img_m_02.10617fe5.png";